<template>
  <div>
    <div v-for="(item,index) in form.skuForm" :key="index">
      <el-form-item label="规格类型：" class="is-required w60">
        <div class="flexs">
          <el-input v-model="item.skuName" placeholder="请输入规格类型" />
          <div class="oper"><span class="del" @click="deleteSku(item,index)">删除</span></div>
        </div>
      </el-form-item>
      <br />
      <el-form-item label="规格名：" class="is-required w60" v-if="item.valueList.length > 0">
        <div class="flexs" v-for="(it,idx) in item.valueList" :key="idx">
          <el-input v-model="it.valueName" placeholder="请输入规格名" />
          <div class="oper"><i class="el-icon-plus" @click="addSkuItem(index,it)"></i><i class="el-icon-minus" @click="deleteSkuItem(it, index,idx)"></i></div>
        </div>
      </el-form-item>
    </div>
    <div class="add-spec"><el-button type="primary" size="medium" icon="el-icon-plus" round @click="addSku">添加商品规格</el-button></div>

    <el-form-item label="规格明细：" class="is-required width100">
      <el-button type="primary" size="medium" @click="generateSkuDetails" plain style="float: right">生成规格明细</el-button>
    </el-form-item>
    <div class="table-list mt20">
      <div class="spec-head">
        <div class="sp-col">规格名</div>
        <div class="sp-col">规格别名</div>
        <div class="sp-col">聚水潭规格编码</div>
        <div class="sp-col">{{isIntegeal?'积分价':'零售价'}}</div>
        <div class="sp-col">总库存</div>
        <div class="sp-col">规格图</div>
        <div class="sp-col">排序</div>
        <div class="sp-col">操作</div>
      </div>
      <!-- // [{"jushuitanCode":"产品编码code","retailPrice":"98.89","specDetail":"794,784","aliasTitle":"别名1","orderNo":0",specImg:"123"}] -->
      <div class="spec-item" v-for="(it, idx) in form.skuList" :key="idx">
        <el-form-item class="sp-col" label-width="0">{{it.spec || '无规格值'}}</el-form-item>
        <el-form-item class="sp-col" :prop="`skuList[${idx}].aliasTitle`" label-width="0">
          <el-input v-model="it.aliasTitle" placeholder="请输入别名" />
        </el-form-item>
        <el-form-item class="sp-col" :prop="`skuList[${idx}].jushuitanCode`" label-width="0" :rules="{required: true,message: '请填写',trigger: 'change',}">
          <el-input v-model="it.jushuitanCode" placeholder="请输入聚水潭规格编码">
            <i slot="suffix" class="el-input__icon el-icon-search" style="cursor: pointer" @click="handleGetYongInfo(it)"></i>
            <!-- <el-button slot="append" icon="el-icon-search" ></el-button> -->
          </el-input>
        </el-form-item>
        <el-form-item class="sp-col" :prop="`skuList[${idx}].retailPrice`" label-width="0" :rules="{required: true,message: '请填写',trigger: 'change',}">
          <el-input v-model="it.retailPrice" :placeholder="isIntegeal?'请输入积分价':'请输入零售价'" />
        </el-form-item>
        <el-form-item class="sp-col" :prop="`skuList[${idx}].surplusStock`" label-width="0">
          <el-input v-model="it.surplusStock" placeholder="请输入总库存" />
        </el-form-item>
        <el-form-item class="sp-col" :prop="`skuList[${idx}].specImg`" label-width="0">
          <imageUpload v-model="it.specImg" width="32" height="32" />
        </el-form-item>
        <el-form-item class="sp-col" :prop="`skuList[${idx}].orderNo`" label-width="0" :rules="{required: true,message: '请填写',trigger: 'change',}">
          <el-input v-model="it.orderNo" placeholder="请输入排序" />
        </el-form-item>
        <div class="sp-col oper-icon">
          <span @click="handleRemoveSku(it,idx)">移除</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { guid } from "@/utils/index"
import sysGoodsApi from '@/api/goods/sysGoods'
import ImageUpload from "@/components/ImageUpload";
import sysToolsApi from '@/api/sys/tools'
import sysGoodsSpecApi from '@/api/goods/sysGoodsSpec'
import sysGoodsSpecValueApi from '@/api/sys/sysGoodsSpecValue'
import sysGoodsSpecValuecombineApi from '@/api/sys/sysGoodsSpecValuecombine'
export default {
  props: ['form', 'isFirstSpec', 'isIntegeal'],
  components: { ImageUpload },
  data() {
    return {
      skuList: [],
      guidStr: guid()
    }
  },
  created() {
    if (this.form.id && +this.isFirstSpec) {
      //处理规格明细
      let arr = []
      this.form.sysGoodsSpecValuecombineList.forEach(item => {
        let { id, specName, jushuitanCode, retailPrice, specDetail, aliasTitle, surplusStock, orderNo, specImg, actualQuantity } = item
        arr.push({ id, specName, jushuitanCode, retailPrice, specDetail, aliasTitle, surplusStock, orderNo, specImg, actualQuantity })
      })
      this.$set(this.form, 'skuList', arr)
      //处理规格
      let skuForm = []
      this.form.specList.forEach(item => {
        skuForm.push({
          id: item.id, skuName: item.name, valueList: item.valueList.map(tt => {
            return { id: tt.id, valueName: tt.name }
          })
        })
      })
      this.$set(this.form, 'skuForm', skuForm)
    } else {
      this.$set(this.form, 'skuForm', [])
    }
  },
  methods: {
    handleGetYongInfo(it) {
      if (!it.jushuitanCode) return this.$message.error('请输入聚水潭编码')
      sysGoodsApi.getGoodsByYongYouCode({ codes: it.jushuitanCode }).then(res => {
        if (res.code === '0') {
          let datas = res.data ? JSON.parse(res.data) : [];
          if (!this.form.unit) this.form.unit = datas.length > 0 ? datas[0].unit : ''
          it.retailPrice = datas.length > 0 ? datas[0].sale_price : '';
          it.actualQuantity = (datas.length > 0 && datas[0].items) ? this.getTotalQty(datas) : 1
        }
      })
      sysGoodsApi.getGoodsQuantityByYongYouCode({ codes: it.jushuitanCode }).then(res => {
        if (res.code === '0') {
          let arr1 = res.data ? res.data : []
          it.surplusStock = arr1.length > 0 ? +arr1[0].qty : 0
        }
      })
    },
    getTotalQty(datas) {
      let totalQty = 0;
      // 遍历 datas 数组
      for (let i = 0; i < datas.length; i++) {
        const data = datas[i];
        // 检查 data 中是否存在 items 属性
        if (data.items) {
          // 遍历 items 数组
          for (let j = 0; j < data.items.length; j++) {
            const item = data.items[j];
            // 检查 item 中是否存在 qty 属性
            if (item.qty) {
              totalQty += item.qty;
            }
          }
        }
      }
      return totalQty;
    },
    addSku() {
      let { skuForm } = this.form;
      let arr = skuForm.concat({ id: 0, skuName: '', valueList: [{ valueName: '', id: 0 }] })
      this.$set(this.form, 'skuForm', arr)
    },
    deleteSku(item, index) {
      if (item.id) {
        sysGoodsSpecApi.updateDeleted({ id: item.id }).then(res => {
          if (res.code === '0') this.form.skuForm.splice(index, 1)
        })
      } else {
        this.form.skuForm.splice(index, 1)
      }
    },
    addSkuItem(index, it) {
      if (!it.valueName) return this.$message.error('请填写规格名')
      this.form.skuForm[index].valueList.push({ valueName: '' })
    },
    deleteSkuItem(it, index, idx) {
      if (it.id) {
        sysGoodsSpecValueApi.updateDeleted({ id: it.id }).then(res => {
          if (res.code === '0') this.form.skuForm[index].valueList.splice(idx, 1)
        })
      } else {
        this.form.skuForm[index].valueList.splice(idx, 1)
      }
    },
    //生成规格明细
    generateSkuDetails() {
      let isHint = 0;
      let { skuForm } = this.form;
      let newSku = []
      skuForm.forEach(item => {
        if (!item.skuName) return isHint = true;
        let configs = []
        item.valueList.forEach(it => {
          if (!it.valueName) return isHint = true;
          configs.push({ id: it.id, value: it.valueName })
        })
        newSku.push({ id: item.id, name: item.skuName, configs })
      });

      if (isHint) return this.$message.error('请完善规格类型或规格名')
      sysGoodsApi.saveProdSpec({
        goodsGuid: this.form.id ? this.form.uuid : this.guidStr,
        specData: JSON.stringify(newSku)
      }).then(res => {
        if (!this.form.id) this.form.uuid = this.guidStr
        let list = res.data || [];
        this.specificationList = list;
        this.onChooseSpecItem()
        // list.forEach(item => {
        //   let data = {
        //     id: item.Id, propName: item.Name, checkList: [], valueList: item.configs.map(tt => {
        //       return { propName: tt.name, propValue: tt.id }
        //     })
        //   }
        //   let i = this.specificationList.findIndex(it => it.propValue === item.Id);
        //   if (i >= 0) {
        //     data.checkList = this.specificationList[i].checkList;
        //     this.specificationList[i].valueList = data.valueList;
        //   } else {
        //     this.specificationList.push(data);
        //   }
        // })
      });
    },
    // generateSku() {
    //   this.specificationList = [{ Id: 1, Name: '规格', config: [{ id: 11, name: '大' }, { id: 2, name: '小' }] }, { Id: 2, Name: '颜色', config: [{ id: 22, name: '红色' }, { id: 33, name: '蓝色' }] }]
    //   this.onChooseSpecItem()
    // },
    //选择规格
    onChooseSpecItem(defaultSkuList = []) {
      let specList = [];
      this.specificationList.forEach((it) => {
        let item = { ...it };
        specList.push(item);
      });
      let { skuList } = this;
      if (specList.length > 0) {
        let results = [];
        let result = [];
        let doExchange = (arr, index) => {
          let list = arr[index].configs;
          // let propName = arr[index].Name;
          for (let i = 0; i < list.length; i++) {
            // let data = { ...list[i] };
            result[index] = { ...list[i] };
            if (index != arr.length - 1) {
              doExchange(arr, index + 1);
            } else {
              results.push(JSON.parse(JSON.stringify(result)));
            }
          }
        };
        doExchange(specList, 0);
        //添加规格
        results.forEach((list) => {
          let specName = list.map((it) => it.name).join(",");
          let specId = list.map((it) => it.id).join(",");
          if (
            skuList.findIndex((it) => {
              let _name = it.specList.map((tt) => tt.name).join(",");
              return specName === _name;
            }) < 0
          ) {

            //defaultSkuList
            let ditem = {
              id: 0,
              jushuitanCode: "",
              retailPrice: "",
              specDetail: specId,
              aliasTitle: "",
              surplusStock: "",
              orderNo: "",
              specImg: "",
            };
            if (defaultSkuList.length > 0) {
              let i = defaultSkuList.findIndex(
                (tt) => tt.specName === specName
              );
              if (i >= 0) Object.assign(ditem, defaultSkuList[i]);
            }
            skuList.push({ specList: list, specName, ...ditem });
          }
        });
        // 去掉被删除的规格
        // for (let i = 0; i < skuList.length; i++) {
        //   if (
        //     results.findIndex((it) => {
        //       let specName = it.map((tt) => tt.name).join(",");
        //       return skuList[i].specName === specName;
        //     }) < 0
        //   ) {
        //     skuList.splice(i, 1);
        //     i--;
        //   }
        // }
      } else {
        this.skuList = [];
      }
      console.log(this.skuList)
      this.$set(this.form, 'skuList', this.skuList)
      this.$forceUpdate();
    },
    handleRemoveSku(it, idx) {
      this.form.skuList.splice(idx, 1)
      this.$forceUpdate();
      if (it.id) sysGoodsSpecValuecombineApi.updateDeleted({ id: it.id })
    }
  }
}
</script>

<style lang="scss" scoped>
.el-form-item--small.el-form-item.w60 {
  width: 70%;
  display: inline-block;
  vertical-align: top;
  input {
    width: 40%;
  }
}
.el-form-item--small.el-form-item.width100 {
  width: 97%;
}
.flexs {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  .oper {
    width: 100px;
    display: inline-block;
    font-size: 16px;
    span {
      padding-left: 20px;
      cursor: pointer;
    }
    .del {
      color: #e73f3f;
      padding-left: 20px;
    }
    i {
      font-size: 20px;
      font-weight: bold;
      color: #5dbde7;
      cursor: pointer;
      &.el-icon-plus {
        padding-left: 20px;
      }
      &.el-icon-minus {
        padding-left: 5px;
      }
    }
  }
}
.table-list {
  border: 1px solid #e4e4e4;
  margin: 0 35px 0 50px;
  .sp-col {
    flex: 1;
    color: #666;
    height: 40px;
    margin-bottom: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-right: 1px solid #e4e4e4;

    &.flex2 {
      // flex-grow: 3;
    }
    ::v-deep .el-form-item__error {
      font-size: 10px;
      right: 0;
      top: 24px;
      text-align: center;
    }

    &:last-child {
      border-right: 0;
    }

    &.enter-param {
      flex: 5;
    }
  }

  .spec-head {
    display: flex;
    font-size: 14px;
    align-items: center;
    background-color: #f9fafc;

    label {
      color: #ff4949;
    }
  }

  .spec-item {
    display: flex;
    font-size: 12px;
    align-items: center;
    border-top: 1px solid #e4e4e4;
    .sp-col {
      .el-input {
        ::v-deep .el-input__inner {
          border: none;
          text-align: center;
        }
      }

      .el-button {
        font-size: 12px;
      }
    }
  }
}
.add-spec {
  padding-left: 140px;
}
.oper-icon {
  span {
    cursor: pointer;
  }
}
</style>